import * as attributes from './attributes';
import { IMAGE_SELECTOR } from './image-selector';
import { CSS_GEMERATOR_STYLE_TAG_ID } from './css-generator-style-tag-id';
import * as updateStrategies from './update-strategies';

export default {
  attributes,
  IMAGE_SELECTOR,
  CSS_GEMERATOR_STYLE_TAG_ID,
  updateStrategies,
};
